import script from "./PostListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PostListItem.vue?vue&type=script&setup=true&lang=js"

import "./PostListItem.vue?vue&type=style&index=0&id=431f6161&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-431f6161"]])

export default __exports__